import __request__ from "routing/request";
export function buildBundle() {
  return __request__("POST", "/cluster/debug/support/bundle/build", null, {}, {
    "Accept": ["application/json"]
  });
}
export function download(filename) {
  return __request__("GET", `/cluster/debug/support/bundle/download/${filename}`, null, {}, {
    "Accept": ["application/octet-stream"]
  });
}
export function listBundles() {
  return __request__("GET", "/cluster/debug/support/bundle/list", null, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(filename) {
  return __request__("DELETE", `/cluster/debug/support/bundle/${filename}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function getClusterManifest() {
  return __request__("GET", "/cluster/debug/support/manifest", null, {}, {
    "Accept": ["application/json"]
  });
}
